define('home/templates/activityFooterPost',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<ul class=\"actions\">\n"
    + ((stack1 = container.invokePartial(partials.activityFooterDefaultActions,depth0,{"name":"activityFooterDefaultActions","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</ul>\n";
},"usePartial":true,"useData":true})

});
